<template lang="pug">
div
  slot
</template>

<script>
export default {
  name: 'km-form',
  provide() {
    return {
      form: this,
    }
  },
  data() {
    return {
      validators: [],
    }
  },
  props: {
    models: {
      type: Object,
      default() {
        return {}
      },
    },
    rules: {
      type: Object,
      default() {
        return {}
      },
    },
    separator: {
      type: String | Number,
      default() {
        return ' :'
      },
    },
    labelWidth: {
      default() {
        return '60px'
      },
    },
    align_type: {
      // left right top
      default() {
        return 'right'
      },
    },
    tipDirection: {
      // right bottom
      default() {
        return 'right'
      },
    },
    showError: {
      type: Boolean,
      default: true,
    },
    hideRequiredAsterisk: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clearValidate() {
      this.validators.forEach((item) => {
        item.clearValidate()
      })
    },
    validate() {
      let count = 0
      let callback
      const promise = new Promise((resolve, reject) => {
        callback = function (flag, errors, invalidFields) {
          flag ? resolve() : reject(errors, invalidFields)
        }
      })
      let flag = true
      this.validators.forEach((validator) => {
        validator.validate('', (errors, invalidFields) => {
          count++
          if (errors) {
            flag = false
          }
          if (count >= this.validators.length) {
            callback(flag, errors, invalidFields)
          }
        })
      })
      return promise
    },
  },
  created() {
    this.$on('addValidate', (validator) => {
      this.validators.push(validator)
    })
    this.$on('removeValidate', (validator) => {
      this.validators = this.validators.filter((item) => item !== validator)
    })
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/ui/components/form/main.vue